import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';

@Component({
    selector: 'app-param-grupo-etiquetas-denominacion',
    templateUrl: './grupo-etiquetas-denominacion.component.html'
})
export class ParamGrupoEtiquetasDenominacionComponent implements OnInit {

    public editable = false;

    public grupoEtiquetasCaja = [];
    public grupoEtiquetasPallet = [];

    public licenciaSwId;
    public denominacionId;
    public almacenId;

    @Input() set grupoEtiquetas(param: any) {
        if (param.gruposEtiquetaAsociados) {
            for (let grupoEtiquetaAsociado of param.gruposEtiquetaAsociados) {
                if (grupoEtiquetaAsociado.marcaId === null) {
                    if (grupoEtiquetaAsociado.tipoConfeccion === 1) {
                        this.grupoEtiquetasCaja.push(grupoEtiquetaAsociado);
                    } else if (grupoEtiquetaAsociado.tipoConfeccion === 2) {
                        this.grupoEtiquetasPallet.push(grupoEtiquetaAsociado);
                    }
                }
            }

            this.licenciaSwId = param.licenciaSwId;
            this.denominacionId = param.denominacionId;
            this.almacenId = param.almacenId;
        }
    };
    @Output() refresh = new EventEmitter<boolean>();
    @Output() pushMessage = new EventEmitter<string>();

    constructor(private readonly _sessionContext: SessionContextService) {}

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public editableChanged(editable) {
        this.editable = editable;
    }

    public toRefresh(value) {
        this.refresh.emit(value);
    }

    ngOnInit() {
    }
}
